import React, { useMemo } from "react";
import { Button } from "antd";
import ViewItemModal from "./viewItemModal";
import CustomTable from "../../table";

const status = {
  done: "Completed",
  cancelled: "Cancelled",
};

const types = {
  dine_in: "Dine In",
  online: "Online Order",
  parcel: "Parcel",
  delivery: "Delivery",
};

const Completed = ({ orders }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({});

  const handleClick = (rowData) => {
    setOpenModal(true);
    setSelectedRow(rowData);
  };

  const completeOrder = useMemo(() => {
    let filterCompleted;
    if (orders.length > 0) {
      filterCompleted = orders?.filter((order) => order.status === "done");
    }
    return filterCompleted;
  }, [orders]);

  const columns = [
    {
      title: "Order id",
      dataIndex: "orderId",
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      render: (orderType) => {
        return <span>{types[orderType]}</span>;
      },
    },
    {
      title: "TABLE NO.",
      dataIndex: "tableNumber",
    },
    {
      title: "SERVED BY",
      dataIndex: "waiterName",
    },
    {
      title: "DATE/TIME",
      render: (rowData) => {
        return (
          <span>
            {rowData.billingDate} {rowData.billingTime}
          </span>
        );
      },
    },
    {
      title: "STATUS",

      render: (rowData) => {
        return (
          <span
            style={
              rowData.status === "done" ? { color: "green" } : { color: "red" }
            }
          >
            {status[rowData.status]}
          </span>
        );
      },
    },
    {
      title: "TOTAL ITEMS",
      render: (rowData) => {
        return <span>{rowData.items.length}</span>;
      },
    },
    {
      title: "ITEM DETAILS",

      render: (rowData) => {
        return (
          <Button type="link" onClick={() => handleClick(rowData)}>
            View Details
          </Button>
        );
      },
    },
  ];
  return (
    <>
      <CustomTable
        columns={columns}
        data={completeOrder}
        title={"Completed Orders"}
        style={{
          minHeight: "calc(100vh - 300px)",
        }}
        emptyContainerStyle={{
          minHeight: "calc(100vh - 300px)",
        }}
      />
      <ViewItemModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        selectedRow={selectedRow}
      />
    </>
  );
};

export default Completed;
